import { FC } from 'react';
import { Button, SxStyleProp } from 'theme-ui';
import Icon, { IconTypes } from 'shared/Icon';

type ToolbarButtonProps = {
  onClickHandler: () => void;
  message: string;
  active?: boolean;
  icon: string;
  disabled?: boolean;
  'data-test'?: string;
};

const defaultButtonStyle: SxStyleProp = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  border: 0,
  width: 64,
  height: 64,
  color: 'grey4',
  transition: 'none',
  position: 'relative',
  '&:not(.active):hover': {
    color: 'grey6',
    svg: { path: { fill: 'text' } }
  }
};

const iconStyle: SxStyleProp = {
  alignSelf: 'center',
  pb: 0.5
};

const leftLineStyles: SxStyleProp = {
  position: 'absolute',
  left: '-8px',
  top: '8px',
  height: '46px',
  width: '3px',
  borderRadius: '3px',
  bg: 'primary'
};

export const ToolbarButton: FC<ToolbarButtonProps> = ({
  onClickHandler,
  message,
  active = false,
  icon,
  disabled = false,
  ...props
}) => {
  return (
    <Button
      variant="secondary"
      sx={{ ...defaultButtonStyle, fontSize: '12px', padding: '0', marginTop: '6px' }}
      onClick={onClickHandler}
      disabled={disabled}
      className={active ? 'active' : null}
      {...props}
    >
      <Icon name={icon} sx={iconStyle} type={active ? IconTypes.Primary : IconTypes.Text2} />
      {message}
      {active && <div sx={leftLineStyles} />}
    </Button>
  );
};
